import React, { useEffect, useState } from "react";
import api from "../auth/api";

export default function AssignTemplatesToChannel() {
    const [channels, setChannels] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState(null);
    const [assigned, setAssigned] = useState([]);

    // Cargar canales y templates
    useEffect(() => {
        api.get("/channels").then((r) => {
            const ch = Array.isArray(r.data)
                ? r.data
                : Array.isArray(r.data.channels)
                    ? r.data.channels
                    : [];

            setChannels(ch);
        });
        api.get("/api/messages/templates").then((r) => {
            console.log("DEBUG TEMPLATES =", r.data);
            const list = Array.isArray(r.data)
                ? r.data
                : Array.isArray(r.data.templates)
                    ? r.data.templates
                    : [];

            setTemplates(list);
        });
    }, []);

    // Cuando cambio de canal, cargo asignaciones
    const loadAssignments = async (channelId) => {
        const r = await api.get(`/api/messages/channels/${channelId}/templates`);
        setAssigned(r.data.map((x) => x.templateId));
    };

    const toggle = (templateId) => {
        setAssigned((prev) =>
            prev.includes(templateId)
                ? prev.filter((id) => id !== templateId)
                : [...prev, templateId]
        );
    };

    const save = async () => {
        await api.post(`/api/messages/channels/${selectedChannel}/templates`, {
            templates: assigned,
        });
        alert("Asignaciones guardadas");
    };

    return (
        <div style={styles.page}>
            {/* Lista de canales */}
            <div style={styles.sidebar}>
                <h3>Canales</h3>
                {channels.map((c) => (
                    <div
                        key={c.id}
                        style={{
                            ...styles.channelItem,
                            background: selectedChannel === c.id ? "#e0f2fe" : "white",
                        }}
                        onClick={() => {
                            setSelectedChannel(c.id);
                            loadAssignments(c.id);
                        }}
                    >
                        {c.name} — {c.phone}
                    </div>
                ))}
            </div>

            {/* Lista de templates */}
            <div style={styles.main}>
                <h2>Asignar plantillas</h2>

                {!selectedChannel ? (
                    <p style={{ color: "#666" }}>Selecciona un canal</p>
                ) : (
                    <>
                        {templates.map((t) => (
                            <label key={t.id} style={styles.templateItem}>
                                <input
                                    type="checkbox"
                                    checked={assigned.includes(t.id)}
                                    onChange={() => toggle(t.id)}
                                />
                                <span style={{ marginLeft: 8 }}>
                                    /{t.command} — {t.title}
                                </span>
                            </label>
                        ))}

                        <button style={styles.saveBtn} onClick={save}>
                            Guardar asignaciones
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}

const styles = {
    page: {
        display: "flex",
        height: "100%",
    },
    sidebar: {
        width: 250,
        borderRight: "1px solid #ddd",
        padding: 10,
        background: "#f8fafc",
    },
    channelItem: {
        padding: 10,
        borderRadius: 6,
        cursor: "pointer",
        marginBottom: 6,
        border: "1px solid #ddd",
    },
    main: {
        flex: 1,
        padding: 20,
    },
    templateItem: {
        display: "block",
        marginBottom: 8,
    },
    saveBtn: {
        marginTop: 10,
        padding: "10px 18px",
        background: "#0ea5e9",
        color: "white",
        borderRadius: 6,
        border: 0,
        cursor: "pointer",
    },
};
